export default {
  change: (currentPrice: number | undefined, previousPrice: number | undefined) => (currentPrice ?? 0) - (previousPrice ?? 0),

  percentChange(currentPrice: number | undefined, previousPrice: number | undefined) {
    if (currentPrice == null || previousPrice == null || previousPrice === 0) return 0; // note "== null" checks against null and undefined
    return (this.change(currentPrice, previousPrice) / previousPrice) * 100;
  },

  changeIcon(currentPrice: number | undefined, previousPrice: number | undefined) {
    const change = this.change(currentPrice, previousPrice);
    if (Math.abs(change) < 5) return false;

    const percent = Math.abs(this.percentChange(currentPrice, previousPrice));
    const direction = change > 0 ? 'up' : 'down';

    if (percent >= 15) return `mdi-chevron-triple-${direction}`;
    if (percent >= 10) return `mdi-chevron-double-${direction}`;
    if (percent >= 5) return `mdi-chevron-${direction}`;
    return false;
  }
};
